module.exports = __webpack_public_path__ + "media/images/ca-rental-homes-3d506be80848b64ac7f0427c52eef16f.png";